"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var Styled = _interopRequireWildcard(require("./style"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var defaultFocusableElementsQuery = ['input:not(:disabled)', 'textarea:not(:disabled)', 'button:not(:disabled)', 'select:not(:disabled)', '[href]', '[tabindex]:not([tabindex="-1"])'];
var FocusTrap = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var children = props.children,
    disabled = props.disabled,
    onKeyDown = props.onKeyDown,
    trapTarget = props.trapTarget,
    focusableElementsQuery = props.focusableElementsQuery,
    useGlobalListener = props.useGlobalListener,
    DOMProps = __rest(props, ["children", "disabled", "onKeyDown", "trapTarget", "focusableElementsQuery", "useGlobalListener"]);
  var _a = (0, _react.useState)(null),
    trapContainerRef = _a[0],
    setTrapContainerRef = _a[1];
  (0, _react.useImperativeHandle)(ref, function () {
    return trapContainerRef;
  }, [trapContainerRef]);
  var handleOnKeyDown = (0, _react.useCallback)(function (event) {
    if (typeof onKeyDown === 'function') {
      onKeyDown(event);
    }
    if (!disabled) {
      if (event.code === 'Tab') {
        var trapContainer = (trapTarget === null || trapTarget === void 0 ? void 0 : trapTarget.current) ? trapTarget.current : trapContainerRef;
        var query = Array.isArray(focusableElementsQuery) && focusableElementsQuery.length ? focusableElementsQuery : defaultFocusableElementsQuery;
        // @ts-ignore
        var elements = Array.from(trapContainer.querySelectorAll(query));
        if (Array.isArray(elements) && elements.length) {
          var firstElement = elements[0];
          var lastElement = elements[elements.length - 1];
          if (event.shiftKey) {
            if (document.activeElement === firstElement) {
              event.preventDefault();
              lastElement.focus();
            }
          } else {
            if (document.activeElement === lastElement) {
              event.preventDefault();
              firstElement.focus();
            }
          }
        } else {
          console.warn("Couldn't find any focusable elements to trap the focus");
        }
      }
    }
  }, [trapContainerRef, disabled, focusableElementsQuery, onKeyDown, trapTarget]);
  (0, _react.useEffect)(function () {
    if (useGlobalListener) {
      window.addEventListener('keydown', handleOnKeyDown);
    }
    return function () {
      if (useGlobalListener) {
        window.removeEventListener('keydown', handleOnKeyDown);
      }
    };
  }, [useGlobalListener, handleOnKeyDown]);
  return (0, _jsxRuntime.jsx)(Styled.Wrapper, __assign({
    ref: setTrapContainerRef,
    onKeyDown: !useGlobalListener ? handleOnKeyDown : undefined
  }, DOMProps, {
    children: children
  }));
});
FocusTrap.displayName = 'FocusTrap';
var _default = FocusTrap;
exports.default = _default;